VjsAdmin.gradeGoogleMapping = (function () {
    const me = {};
    const districtGuid = $('.district-info').data('district-guid');
    const platform = $('.platform-info').data('platform-id');
    const attributeType = 'grade';

    const init = function () {
        new GradeMappingClickEvent();
        const MappingView = new AddMappingView();
        MappingView.render();
    };
    // Theses need to be added to a common library
    const successAlert = function (alertMessage) {
        console.log('itwas a success');
        const alert = `<div class="alert alert-success" role="alert">\
                            <i class="fa fa-thumbs-o-up" aria-hidden="true"></i>\
                            <span>${alertMessage}</span>\
                            <a href="#" class="close" data-dismiss="alert" aria-label="close">×</a>\
                        </div>`;

        $('.alert-div').html(alert);
    };
    const dangerAlert = function (alertMessage) {
        const alert = `<div class="alert alert-danger" role="alert">\
                            <span>${alertMessage}</span>\
                        </div>`;
        $('.alert-div').html(alert);
    };

    const GradeMappingClickEvent = VjsUtility.Controller.extend({
        events: {
            'change #year-mapping-checkbox': 'changeYearMappingCheckbox',
        },
        changeYearMappingCheckbox(e) {
            const checkboxValue = {
                year_detect: $(e.target).prop('checked'),
            };

            const req = new VjsUtility.Request();
            req.put(`/platforms/${platform}/districts/${districtGuid}/google/grade-mapping/detect`, checkboxValue)
                .done(() => {
                    successAlert('Detect year mapping successfuly changed!');
                })
                .fail((x) => {
                    dangerAlert(x.responseJSON.data);
                })
                .always(() => {});
        },
    });

    const AddMappingView = VjsUtility.View.extend({
        parent: '#view-body',
        templateUrl: '/assets/templates/google/mapping/component-mapping-template.html',
        events: {
            'click #add-direct-mapping': 'clickAddDirectMapping',
        },
        after() {
            const req = new VjsUtility.Request();
            req.get(`/platforms/${platform}/districts/${districtGuid}/google/direct-mapping/list/?attribute_type=${attributeType}`)
                .done((res) => {
                    res.forEach((obj) => {
                        const thisMapping = $(`.mapping-component[data-mapping-id="${obj.conditional_key}"]`);
                        const DirectMappingComponent = new me.DirectMappingComponentView();
                        DirectMappingComponent.parent = $(thisMapping).find('.mapping-items-view');
                        DirectMappingComponent.templateUrl = '/assets/templates/google/mapping/direct-mapping-component.html';
                        DirectMappingComponent.thisLicenseMapping = thisMapping;
                        DirectMappingComponent.render({
                            mapping_key: obj.conditional_key,
                            mapping_value: obj.conditional_value,
                            id: obj.id,
                        });
                    });
                })
                .fail((x) => {
                    console.log(x.responseJSON.data);
                })
                .always(() => {});
        },
        clickAddDirectMapping(e) {
            const thisLicenseMapping = $(e.currentTarget).closest('.mapping-component');
            const DirectMappingComponent = new me.DirectMappingComponentView();
            DirectMappingComponent.parent = $(thisLicenseMapping).find('.mapping-items-view');
            DirectMappingComponent.templateUrl = '/assets/templates/google/mapping/new-direct-mapping-component.html';
            DirectMappingComponent.thisLicenseMapping = thisLicenseMapping;
            DirectMappingComponent.render({
                mapping_key: $(e.currentTarget).data('mapping-key'),
                mapping_value: '',
            });
            $('.edit-direct-mapping').attr('disabled', true);
            $('.add-direct-mapping').attr('disabled', true);
        },
    });

    me.DirectMappingComponentView = VjsUtility.View.extend({
        parent: '',
        thisLicenseMapping: '',
        events: {
            'click .save-direct-mapping': 'clickSaveDirectMapping',
            'click .delete-direct-mapping': 'clickDeleteDirectMapping',
            'click .edit-direct-mapping': 'clickEditDirectMapping',
            'click .cancel-direct-mapping': 'clickCancelDirectMapping',
        },
        after() {
            const addedLicenseMappings = $(this.thisLicenseMapping).find('.added-mapping-items');
            $(this.parent).find('.direct-mapping-component').detach().appendTo(addedLicenseMappings);
        },
        clickSaveDirectMapping(e) {
            // On click save the mapping to the database
            const thisMapping = e.currentTarget;
            const createMappingData = {
                mapping_value: $(thisMapping).closest('.direct-mapping-component').find('.orgunit-name').val(),
                mapping_key: $(thisMapping).closest('.direct-mapping-component').find('.orgunit-name').data('mapping-key'),
                id: $(thisMapping).data('mapping-id'),
                attribute_type: attributeType,
            };
            const req = new VjsUtility.Request();
            req.put(`/platforms/${platform}/districts/${districtGuid}/google/direct-mapping/`, createMappingData)
                .done((x) => {
                    $('.direct-mapping-component').detach();
                    const MappingView = new AddMappingView();
                    MappingView.render();
                    $('.edit-direct-mapping').attr('disabled', false);
                    $('.add-direct-mapping').attr('disabled', false);
                    successAlert('Mapping successfuly saved!');
                    dangerAlert(x.responseJSON.data);
                })
                .fail((x) => {
                    dangerAlert(x.responseJSON.data);
                })
                .always(() => {});
        },
        clickDeleteDirectMapping(e) {
            const mappingId = $(e.currentTarget).data('mapping-id');
            const req = new VjsUtility.Request();
            req.delete(`/platforms/${platform}/districts/${districtGuid}/google/direct-mapping/${mappingId}`)
                .done(() => {
                    $('.direct-mapping-component').detach();
                    const MappingView = new AddMappingView();
                    MappingView.render();
                    $('.edit-direct-mapping').attr('disabled', false);
                    $('.add-direct-mapping').attr('disabled', false);
                    successAlert('Mapping successfuly deleted!');
                })
                .fail((x) => {
                    dangerAlert(x.responseJSON.data);
                })
                .always(() => {});
        },
        clickEditDirectMapping(e) {
            $(e.currentTarget).parent('.edit-button').attr('hidden', true);
            $(e.currentTarget).closest('.direct-mapping-component').find('.action-buttons').removeAttr('hidden');
            $(e.currentTarget).closest('.direct-mapping-component').find('.orgunit-name').removeAttr('disabled');
            $('.edit-direct-mapping').attr('disabled', true);
            $('.add-direct-mapping').attr('disabled', true);
        },
        clickCancelDirectMapping() {
            $('.direct-mapping-component').detach();
            const MappingView = new AddMappingView();
            MappingView.render();
            $('.edit-direct-mapping').attr('disabled', false);
            $('.add-direct-mapping').attr('disabled', false);
        },
    });

    return {
        init,
    };
}());
